import Helpers from '@helpers';

const affiliateCookies = () => {

    window.addEventListener("load", function () {

        var param1 = 'utm_source';
        var param2 = 'tatoken';
        var param3 = 'clickid';
        var param4 = '_yngt';
        var param5 = 'referrer';
        var param6 = 'utm_medium';
        var param7 = 'affid';
        var domain = 'meghdadit.com';
        //expires
        var affilioExp = 'exp';

        var paramVal1 = Helpers.Utils.getParameterByName(param1, null);
        var paramVal2 = Helpers.Utils.getParameterByName(param2, null);
        var paramVal3 = Helpers.Utils.getParameterByName(param3, null);
        var paramVal4 = Helpers.Utils.getCookie(param4);
        var paramVal5 = Helpers.Utils.getParameterByName(param5, null);
        var paramVal6 = Helpers.Utils.getParameterByName(param6, null);
        var paramVal7 = Helpers.Utils.getParameterByName(param7, null);

        if (paramVal1) {
            var paramVal1Lc = paramVal1.toLowerCase();
        }
        if (paramVal6) {
            var paramVal6Lc = paramVal6.toLowerCase();
        }

        if (paramVal1) {
            var expires = "";
            var date = new Date();

            if (paramVal1Lc === "takhfifan" && paramVal2) {
                date.setTime(date.getTime() + (7/*days to expire*/ * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();

                document.cookie = "affiliate_source=" + paramVal1 + expires + "; path=/; domain=" + domain + "; SameSite=None;Secure";
                document.cookie = "affiliate_token=" + paramVal2 + expires + "; path=/; domain=" + domain + "; SameSite=None;Secure";
            }
            else if (paramVal1Lc === "deema" && paramVal3) {
                date.setTime(date.getTime() + (7/*days to expire*/ * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();

                document.cookie = "affiliate_source=" + paramVal1 + expires + "; path=/; domain=" + domain + "; SameSite=None;Secure";
                document.cookie = "affiliate_token=" + paramVal3 + expires + "; path=/; domain=" + domain + "; SameSite=None;Secure";
            }
            else if (paramVal1Lc === "chavosh" && paramVal4) {
                date.setTime(date.getTime() + (30/*days to expire*/ * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();

                document.cookie = "affiliate_source=" + Helpers.Utils.getCookie("analytics_campaign") + expires + "; path=/; domain=" + domain + ";SameSite=None;Secure";
                document.cookie = "affiliate_token=" + paramVal4 + expires + "; path=/; domain=" + domain + ";SameSite=None;Secure";
            }
            else if (paramVal1Lc === "affili" && paramVal5) {
                date.setTime(date.getTime() + (30/*days to expire*/ * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();

                document.cookie = "affiliate_source=" + paramVal1 + expires + "; path=/; domain=" + domain + "; SameSite=None;Secure";
                document.cookie = "affiliate_token=" + paramVal5 + expires + "; path=/; domain=" + domain + "; SameSite=None;Secure";
            }
            else if (paramVal6Lc === "affilio" && paramVal7) {
                var exp = Helpers.Utils.getParameterByName(affilioExp, null);
                date.setTime(date.getTime() + (parseInt(exp)/*days to expire*/ * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
                document.cookie = "affiliate_source=" + paramVal6 + expires + "; path=/; domain=" + domain + ";SameSite=None;Secure";
                document.cookie = "affiliate_token=" + paramVal7 + expires + "; path=/; domain=" + domain + ";SameSite=None;Secure";
            }
        }
    });

};

export {
    affiliateCookies
};
